import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Container } from '@mui/material';
import { setCompanyUUID, getActAs } from 'store/slices/user';
import { useDispatch } from 'store';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


const TimerBar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [time, setTime] = useState(0); // Time in seconds

    const adminName = useSelector((state) => state.user.profile.name);

    const getUserType = () => {
        return localStorage.getItem("userType"); // Default to 'ca' if not found
    };
    const userType = getUserType();

    const handleStop = () => {
        console.log(userType);
        dispatch(getActAs('')) // Dispatch action to set `actass` to false
        if (userType === 'admin') {
            navigate('/admin/organization');
        } else if (userType === 'ca') {
            navigate('/ca/organization');
        }
    };


    // Convert seconds to HH:MM:SS format
    const formatTime = (seconds) => {
        const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
        const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        const s = String(seconds % 60).padStart(2, '0');
        return `${h}:${m}:${s}`;
    };

    // Increment time every second
    useEffect(() => {
        const timer = setInterval(() => setTime((prevTime) => prevTime + 1), 1000);
        return () => clearInterval(timer); // Cleanup on unmount
    }, []);

    return (
        <Container position="static" sx={{ backgroundColor: 'red', height: { xs: '85px', md: '40px', lg: '40px' }, width: '50vw', padding: '2px', alignContent: 'center', borderRadius: '25px', display: { xs: 'block', md: 'flex', lg: 'flex' }, justifyContent: 'space-between' }}>
            <Typography sx={{ color: 'white', textAlign: 'center', alignContent: 'center', fontWeight: 'bold', }}>
                {`Admin User : ${adminName}`}
            </Typography>
            <Typography sx={{ color: 'white', textAlign: 'center', alignContent: 'center', fontWeight: 'bold', }}>
                User Mocking Interface
            </Typography>
            <Typography style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', fontWeight: 'bold' }}>
                <Typography style={{ marginRight: 15, color: 'white', textAlign: 'center', alignContent: 'center' }}>{formatTime(time)}</Typography>
                <Button variant="text" sx={{ backgroundColor: 'transparent', fontWeight: 'bold', color: 'white' }} onClick={handleStop}>
                    EXIT
                </Button>
            </Typography>
        </Container>
    );
};

export default TimerBar;
